import { useState } from "react";
import { authService } from "../utils/authService";
import axiosInstance from "../utils/axiosConfig";

export const useChecklist = (selectedSchedule, setSelectedSchedule) => {
  const [localNotes, setLocalNotes] = useState({});

  const handleChecklistItemChange = async (questionId, completed) => {
    setSelectedSchedule((prev) => ({
      ...prev,
      schedule_checklists: prev.schedule_checklists.map((cl) =>
        cl.checklist_question_id === questionId ? { ...cl, completed } : cl
      ),
    }));

    const response = await axiosInstance.patch(
      `/schedules/${selectedSchedule.id}/checklist/${questionId}`,
      {
        checklist: {
          completed,
        },
      }
    );

    setSelectedSchedule((prev) => ({
      ...prev,
      schedule_checklists: prev.schedule_checklists.map((cl) =>
        cl.checklist_question_id === questionId
          ? { ...cl, completed: !completed }
          : cl
      ),
    }));
  };

  const handleSaveNotes = async (questionId) => {
    const notes = localNotes[questionId];
    const response = await axiosInstance.patch(
      `/schedules/${selectedSchedule.id}/checklist/${questionId}`,
      {
        checklist: { notes },
      }
    );

    setSelectedSchedule((prev) => ({
      ...prev,
      schedule_checklists: prev.schedule_checklists.map((cl) =>
        cl.checklist_question_id === questionId ? { ...cl, notes } : cl
      ),
    }));
  };

  const handleLocalNotesChange = (questionId, notes) => {
    setLocalNotes((prev) => ({
      ...prev,
      [questionId]: notes,
    }));
  };

  return {
    localNotes,
    handleChecklistItemChange,
    handleSaveNotes,
    handleLocalNotesChange,
  };
};
